<template>
  <div class="flair-select-container">
    <!-- 禁用状态下的标签展示 -->
    <div v-if="disabled" class="disabled-display">
      <div v-if="identityType && !hideIdentityType" class="disabled-section">
        <div class="disabled-title">您的身份：</div>
        <div class="disabled-tags">
          <div class="disabled-tag">
            {{ getIdentityTypeLabel(identityType) }}
          </div>
        </div>
      </div>

      <div v-if="selectedTypes.length > 0" class="disabled-section">
        <div class="disabled-title">客户类型：</div>
        <div class="disabled-tags">
          <div v-for="type in selectedTypes" :key="type" class="disabled-tag">
            {{ getCustomerTypeLabel(type) }}
          </div>
        </div>
      </div>

      <div v-if="selectedEnterpriseLabels.length > 0" class="disabled-section">
        <div class="disabled-title">企业资质：</div>
        <div class="disabled-tags">
          <div v-for="label in selectedEnterpriseLabels" :key="label" class="disabled-tag">
            {{ label }}
          </div>
        </div>
      </div>

      <div v-if="selectedPersonalLabels.length > 0" class="disabled-section">
        <div class="disabled-title">个人资质：</div>
        <div class="disabled-tags">
          <div v-for="label in selectedPersonalLabels" :key="label" class="disabled-tag">
            {{ label }}
          </div>
        </div>
      </div>

      <div v-if="selectedMerchantLabels.length > 0" class="disabled-section">
        <div class="disabled-title">商户资质：</div>
        <div class="disabled-tags">
          <div v-for="label in selectedMerchantLabels" :key="label" class="disabled-tag">
            {{ label }}
          </div>
        </div>
      </div>
      <div v-if="loanServerList && loanServerList.length > 0" class="disabled-section">
        <div class="disabled-title">助贷服务：</div>
        <div class="disabled-tags">
          <div v-for="server in loanServerList" :key="server" class="disabled-tag">
            {{ getLoanServerLabel(server) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 可编辑状态下的选择界面 -->
    <template v-else>
      <!-- 您的身份选择 -->
      <div v-if="!hideIdentityType" class="identity-type">
        <div class="tw-flex">
          <div class="title">
            <span class="required" v-if="required">*</span>
            您的身份
          </div>
          <div class="options">
            <div
              v-for="item in identityTypeOptions"
              :key="item.value"
              :class="['option-item', { active: identityType === item.value }]"
              @click="toggleIdentityType(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div v-if="errors.identityType" class="error-message">{{ errors.identityType }}</div>
      </div>

      <!-- 客户类型选择 -->
      <div v-if="showCustomerType" class="customer-type tw-mb-[16px] tw-mt-[16px]">
        <div class="tw-flex">
          <div class="title">
            <span class="required" v-if="required">*</span>
            客户类型
          </div>
          <div class="options">
            <div
              v-for="item in customerTypeOptions"
              :key="item.value"
              :class="['option-item', { active: selectedTypes.includes(item.value) }]"
              @click="toggleCustomerType(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div v-if="errors.customerType" class="error-message">{{ errors.customerType }}</div>
      </div>
      <!-- 是否展示二级选项 -->
      <template v-if="showSecondaryOptions">
        <!-- 企业资质选项 -->
        <div
          v-if="showCustomerType && selectedTypes.includes(SpeacializeEnum.enterprise)"
          class="qualification-section"
        >
          <div class="tw-flex">
            <div class="title">
              <span class="required" v-if="required">*</span>
              企业资质
            </div>
            <div class="options">
              <div
                v-for="item in enterpriseOptions"
                :key="item.value"
                :class="['option-item', { active: modelValue.includes(item.value) }]"
                @click="toggleSelection(item.value)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>

          <div v-if="errors.enterprise" class="error-message">{{ errors.enterprise }}</div>
        </div>

        <!-- 个人资质选项 -->
        <div
          v-if="showCustomerType && selectedTypes.includes(SpeacializeEnum.person)"
          class="qualification-section"
        >
          <div class="tw-flex">
            <div class="title">
              <span class="required" v-if="required">*</span>
              个人资质
            </div>
            <div class="options">
              <div
                v-for="item in personalOptions"
                :key="item.value"
                :class="['option-item', { active: modelValue.includes(item.value) }]"
                @click="toggleSelection(item.value)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div v-if="errors.personal" class="error-message">{{ errors.personal }}</div>
        </div>
        <!-- 商户资质选项 -->
        <div
          v-if="showCustomerType && selectedTypes.includes(SpeacializeEnum.business)"
          class="qualification-section"
        >
          <div class="tw-flex">
            <div class="title">
              <span class="required" v-if="required">*</span>
              商户资质
            </div>
            <div class="options">
              <div
                v-for="item in merchantOptions"
                :key="item.value"
                :class="['option-item', { active: modelValue.includes(item.value) }]"
                @click="toggleSelection(item.value)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div v-if="errors.merchant" class="error-message">{{ errors.merchant }}</div>
        </div>
      </template>
      <!-- 助贷服务选择列表 -->
      <div v-if="showLoanServerList" class="loan-server-list tw-mt-[16px]">
        <div class="tw-flex">
          <div class="title">
            <span class="required" v-if="required">*</span>
            助贷服务
          </div>
          <div class="options">
            <div
              v-for="item in loanServerOptions"
              :key="item.value"
              :class="[
                'option-item',
                { active: loanServerList && loanServerList.includes(item.value) }
              ]"
              @click="toggleLoanServer(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div v-if="errors.loanServer" class="error-message">{{ errors.loanServer }}</div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType, reactive, onMounted, watch } from 'vue'
import { SpeacializeEnum, IdentityEnum, identityCustomer } from '../config/index'
import { useOrgInfoStore } from '@/stores/modules/orgInfo'

export default defineComponent({
  name: 'FlairSelect',
  props: {
    modelValue: {
      type: Array as PropType<number[]>,
      default: () => []
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    identityType: {
      type: Number as PropType<number>,
      default: 0
    },
    loanServerList: {
      type: Array as PropType<number[]>,
      default: () => []
    },
    hideIdentityType: {
      type: Boolean,
      default: false
    },
    showSecondaryOptions: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    'update:modelValue',
    'update:identityType',
    'update:loanServerList',
    'validate',
    'changeValue'
  ],
  setup(props, { emit }) {
    // 您的身份
    const identityTypeOptions = [
      { label: '助贷中介', value: IdentityEnum.intermediary },
      { label: '贷款客户', value: IdentityEnum.customer },
      { label: '其他服务', value: IdentityEnum.service }
    ]

    // 客户类型选项
    const customerTypeOptions = [
      { label: '企业', value: SpeacializeEnum.enterprise },
      { label: '个人', value: SpeacializeEnum.person },
      { label: '商户', value: SpeacializeEnum.business }
    ]

    // 助贷服务选项
    const loanServerOptions = computed(() => {
      return identityCustomer.children || []
    })

    // 是否显示助贷服务列表
    const showLoanServerList = computed(() => {
      return props.identityType === IdentityEnum.service
    })

    // 是否显示客户类型选择
    const showCustomerType = computed(() => {
      // 如果需要隐藏身份类型选择，则始终显示客户类型
      if (props.hideIdentityType) {
        return true
      }
      return (
        props.identityType === IdentityEnum.intermediary ||
        props.identityType === IdentityEnum.customer
      )
    })

    // 选中的客户类型
    const selectedTypes = ref<number[]>([])

    // 验证错误信息
    const errors = reactive({
      identityType: '',
      loanServer: '',
      customerType: '',
      enterprise: '',
      personal: '',
      merchant: ''
    })
    const { speacializeOptions } = useOrgInfoStore()
    // 企业资质选项
    const enterpriseOptions = computed(() => {
      return speacializeOptions[0].children || []
    })

    // 个人资质选项
    const personalOptions = computed(() => {
      return speacializeOptions[1].children || []
    })

    // 商户资质选项
    const merchantOptions = computed(() => {
      return speacializeOptions[2].children || []
    })

    // 获取值属于哪个类型
    const getValueType = (value: number): number | null => {
      for (let i = 0; i < speacializeOptions.length; i++) {
        const children = speacializeOptions[i].children || []
        if (children.some(item => item.value === value)) {
          // 返回该选项所属的类型值
          return Number(speacializeOptions[i].value)
        }
      }
      return null
    }

    // 获取类型所有的值
    const getTypeValues = (type: number): number[] => {
      const typeIndex = speacializeOptions.findIndex(item => String(type).startsWith(item.value))
      if (typeIndex === -1) return []

      const children = speacializeOptions[typeIndex].children || []
      return children.map(item => item.value)
    }

    // 根据传入值设置客户类型
    const updateSelectedTypes = () => {
      const currentTypes = new Set<number>(props.modelValue)

      // 只有在显示客户类型时才添加类型
      if (showCustomerType.value) {
        props.modelValue.forEach(value => {
          const type = getValueType(value)
          if (type !== null) {
            currentTypes.add(type)
          }
        })
      }

      // 将用户选择的类型与从modelValue中解析出的类型合并
      selectedTypes.value = Array.from(currentTypes)

      validate()
    }

    watch(
      [() => props.modelValue, () => props.identityType, () => props.loanServerList],
      () => {
        updateSelectedTypes()
        if (props.required) {
          validate()
        }
      },
      { deep: true }
    )

    // 初始化时设置客户类型
    onMounted(() => {
      updateSelectedTypes()
    })

    // 切换身份类型选择
    const toggleIdentityType = (value: number) => {
      // 如果已经选中，则不做操作
      if (props.identityType === value) {
        return
      }

      // 直接设置新值
      emit('update:identityType', value)

      // 如果之前选择的是助贷服务，但现在不是，则清空助贷服务列表
      if (props.identityType === IdentityEnum.service && value !== IdentityEnum.service) {
        emit('update:loanServerList', [])
      }

      validate()
    }

    // 切换助贷服务选择
    const toggleLoanServer = (value: number) => {
      const newLoanServerList = [...props.loanServerList]
      const index = newLoanServerList.indexOf(value)

      if (index > -1) {
        newLoanServerList.splice(index, 1)
      } else {
        newLoanServerList.push(value)
      }

      emit('update:loanServerList', newLoanServerList)
    }

    // 切换客户类型选择
    const toggleCustomerType = (value: number) => {
      const index = selectedTypes.value.indexOf(value)
      if (index > -1) {
        selectedTypes.value.splice(index, 1)
        // 移除相应类型的资质选项
        removeSelectionsByType(value)
      } else {
        selectedTypes.value.push(value)
      }

      validate()
      emit('update:modelValue', selectedTypes.value)
      // 手动触发一个变更事件，让父组件知道选择已更改
      emit('changeValue', props.modelValue)
    }

    // 移除指定类型的所有选项
    const removeSelectionsByType = (type: number) => {
      const typeValues = getTypeValues(type)
      const newValue = props.modelValue.filter(val => !typeValues.includes(val))
      emit('update:modelValue', newValue)
      emit('changeValue', newValue)
    }

    // 切换选择状态
    const toggleSelection = (value: number) => {
      const newValue = [...props.modelValue]
      const index = newValue.indexOf(value)

      if (index > -1) {
        newValue.splice(index, 1)
      } else {
        newValue.push(value)
      }

      emit('update:modelValue', newValue)
      emit('changeValue', newValue)
    }

    // 验证表单
    const validate = () => {
      // 重置错误信息
      errors.identityType = ''
      errors.loanServer = ''
      errors.customerType = ''
      errors.enterprise = ''
      errors.personal = ''
      errors.merchant = ''

      let isValid = true

      // 验证是否选择了身份类型（仅当不隐藏身份类型时验证）
      if (!props.hideIdentityType && !props.identityType) {
        errors.identityType = '请选择您的身份'
        isValid = false
      }

      // 如果选择了助贷服务，验证是否选择了至少一个助贷服务
      if (
        props.identityType === IdentityEnum.service &&
        props?.loanServerList &&
        props?.loanServerList.length === 0
      ) {
        errors.loanServer = '请至少选择一项助贷服务'
        isValid = false
      }

      // 验证是否选择了至少一个客户类型（仅当需要显示客户类型时）
      if (showCustomerType.value && selectedTypes.value.length === 0) {
        errors.customerType = '请至少选择一种客户类型'
        isValid = false
      }

      // 验证每个选中的客户类型下是否选择了至少一个资质
      if (props.showSecondaryOptions && selectedTypes.value.includes(SpeacializeEnum.enterprise)) {
        const enterpriseValues = getTypeValues(SpeacializeEnum.enterprise)
        const hasEnterpriseSelection = props.modelValue.some(val => enterpriseValues.includes(val))
        if (!hasEnterpriseSelection) {
          errors.enterprise = '请至少选择一种企业资质'
          isValid = false
        }
      }

      if (props.showSecondaryOptions && selectedTypes.value.includes(SpeacializeEnum.person)) {
        const personValues = getTypeValues(SpeacializeEnum.person)
        const hasPersonalSelection = props.modelValue.some(val => personValues.includes(val))
        if (!hasPersonalSelection) {
          errors.personal = '请至少选择一种个人资质'
          isValid = false
        }
      }

      if (props.showSecondaryOptions && selectedTypes.value.includes(SpeacializeEnum.business)) {
        const businessValues = getTypeValues(SpeacializeEnum.business)
        const hasMerchantSelection = props.modelValue.some(val => businessValues.includes(val))
        if (!hasMerchantSelection) {
          errors.merchant = '请至少选择一种商户资质'
          isValid = false
        }
      }

      emit('validate', isValid)
      return isValid
    }

    // 获取身份类型标签
    const getIdentityTypeLabel = (value: number): string => {
      const option = identityTypeOptions.find(item => item.value === value)
      return option ? option.label : ''
    }

    // 获取助贷服务标签
    const getLoanServerLabel = (value: number): string => {
      const option = loanServerOptions.value.find(item => item.value === value)
      return option ? option.label : ''
    }

    // 获取客户类型标签
    const getCustomerTypeLabel = (value: number): string => {
      const option = customerTypeOptions.find(item => item.value === value)
      return option ? option.label : ''
    }

    // 获取已选企业资质标签
    const selectedEnterpriseLabels = computed(() => {
      return props.modelValue
        ?.filter(value => getValueType(value) === SpeacializeEnum.enterprise)
        .map(value => {
          const option = enterpriseOptions.value.find(item => item.value === value)
          return option ? option.label : ''
        })
    })

    // 获取已选个人资质标签
    const selectedPersonalLabels = computed(() => {
      return props.modelValue
        ?.filter(value => getValueType(value) === SpeacializeEnum.person)
        .map(value => {
          const option = personalOptions.value.find(item => item.value === value)
          return option ? option.label : ''
        })
    })

    // 获取已选商户资质标签
    const selectedMerchantLabels = computed(() => {
      return props.modelValue
        ?.filter(value => getValueType(value) === SpeacializeEnum.business)
        .map(value => {
          const option = merchantOptions.value.find(item => item.value === value)
          return option ? option.label : ''
        })
    })

    return {
      identityTypeOptions,
      customerTypeOptions,
      loanServerOptions,
      selectedTypes,
      enterpriseOptions,
      personalOptions,
      merchantOptions,
      showLoanServerList,
      showCustomerType,
      toggleIdentityType,
      toggleLoanServer,
      toggleCustomerType,
      toggleSelection,
      errors,
      validate,
      SpeacializeEnum,
      getIdentityTypeLabel,
      getLoanServerLabel,
      getCustomerTypeLabel,
      selectedEnterpriseLabels,
      selectedPersonalLabels,
      selectedMerchantLabels,
      getTypeValues
    }
  }
})
</script>

<style scoped>
.flair-select-container {
  margin-bottom: 20px;
}

.title {
  font-size: 14px;
  font-weight: 500;
  margin-right: 20px;
  padding-top: 10px;
  color: #666;
  flex-shrink: 0;
}

.required {
  color: #f56c6c;
  margin-left: 4px;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.option-item {
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.option-item:hover {
  background-color: #ebeef5;
}

.option-item.active {
  background-color: #e6f1fc;
  color: #409eff;
  border: 1px solid #b3d8ff;
}

.qualification-section {
  margin-top: 16px;
}

/* 禁用状态下的样式 */

.disabled-section {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.disabled-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-right: 10px;
  min-width: 70px;
}

.disabled-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.disabled-tag {
  color: #333;

  display: flex;
  align-items: center;
}
</style>
